import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServicecallService } from 'src/app/services/servicecall.service';
import * as moment from "moment-timezone";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-export-table',
  templateUrl: './export-table.component.html',
  styleUrls: ['./export-table.component.css']
})
export class ExportTableComponent implements OnInit, OnDestroy {

  exportDataForm: FormGroup;
  userSubmit: boolean = false;
  minDate: any = new Date();
  errorMsg: any;
  private _defaultStartDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
  private _sevenDaysDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7, 0, 0, 0, 999);
  private _exportUrl: any;
  private _exportEntityDataSubscription: Subscription;

  constructor(private _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private _dialog: MatDialog,
    private _service: ServicecallService,
    private _datePipe: DatePipe) {

  }
  ngOnInit(): void {
    this._initiazileForm(this.data);
  }
  ngOnDestroy(): void {
    this._exportEntityDataSubscription?.unsubscribe();
  }
  todayData(type: any) {
    if (type === 'today') {
      this.exportDataForm.patchValue({
        startDate: this._defaultStartDate,
        endDate: this.minDate
      });
      this.exportDataForm.controls['startDate'].disable();
      this.exportDataForm.controls['endDate'].disable();
    } else if (type === 'Last7days') {
      this.exportDataForm.patchValue({
        startDate: this._sevenDaysDate,
        endDate: this.minDate
      });
      this.exportDataForm.controls['startDate'].disable();
      this.exportDataForm.controls['endDate'].disable();
    } else if (type === 'Custom') {
      this.exportDataForm.controls['startDate'].enable();
      this.exportDataForm.controls['endDate'].enable();
      this.exportDataForm.controls['startDate'].reset();
      this.exportDataForm.controls['endDate'].reset();
    }
    this.exportDataForm.controls['startTime'].reset();
    this.exportDataForm.controls['endTime'].reset();
    this.exportDataForm.controls['startDate'].updateValueAndValidity();
    this.exportDataForm.controls['endDate'].updateValueAndValidity();
  }
  closeModal() {
    this._dialogRef.close();
  }

  onSubmit() {
    this.userSubmit = true;
    if (this.exportDataForm.invalid && this.userSubmit) {
      return;
    } else {
      this._exportData();
    }
  }
  get exportDataFormValues() {
    return this.exportDataForm.controls;
  }
  
  private _exportData() {
    this.errorMsg = null;
    const startTime = this.exportDataForm.getRawValue().startTime;
    const endTime = this.exportDataForm.getRawValue().endTime;
    const startDate = this.exportDataForm.getRawValue().startDate;
    const endDate = this.exportDataForm.getRawValue().endDate;
    let transformedStartDate: any;
    let transformedEndDate: any;
    if (startTime && endTime) {
      transformedStartDate = startDate.setHours(startTime.split(':')[0], startTime.split(':')[1]).toString();
      transformedEndDate = endDate.setHours(endTime.split(':')[0], endTime.split(':')[1]).toString();
      if (startTime > endTime && startDate.getDate() === endDate.getDate()) {
        this.errorMsg = "Start time should not be greater than end time!";
      }
    }
    if (this.errorMsg) {
      return;
    } else {
      const reqData = {
        from: this._datePipe.transform(transformedStartDate ? transformedStartDate : startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        to: this._datePipe.transform(transformedEndDate ? transformedEndDate : endDate, 'yyyy-MM-ddTHH:mm:ssZ'),
        entityId: this.data?.exportDetails?._id,
        siteId: this.data?.exportDetails?.site?._id,
        timeZone: moment.tz.guess()
      }

      this._exportEntityDataSubscription = this._service.exportEntityData(reqData).subscribe((resp: any) => {
        if (resp.status) {
          if (resp.response) {
            this._exportUrl = resp.response.data;
            // this.service.toasterService({ type: 'success', msg: resp["response"]["message"] });
            if (resp.response.data) {
              window.open(resp.response.data, "_blank");
              this._dialogRef.close(true);
            }
          } else {
            this._service.toasterService({ type: 'error', msg: resp["response"]["message"] });
          }
        } else {
          this._service.toasterService({ type: 'error', msg: resp["response"]["message"] });
        }
      })
    }

  }
  private _initiazileForm(details: any) {
    const data = details?.exportDetails;
    this.exportDataForm = this._fb.group({
      site: [data ? data.site?.name : '', [Validators.required]],
      patientName: [data ? data.patientName : '', [Validators.required]],
      patientId: [data ? data.patientId : '', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: [this.minDate, [Validators.required]],
      startTime: [''],
      endTime: ['']
    });
    this.todayData('today');
    this.exportDataForm.controls['patientName'].disable();
    this.exportDataForm.controls['patientId'].disable();
    if (data?.site) {
      this.exportDataForm.patchValue({ site: data.site?.name });
      this.exportDataForm.controls['site'].disable();
    }
  }


}
